import { LOBBY_ACTIONS } from './constants';

const initialState = {
  lobby: {},
  error: null,
  isFetching: false,
  isJoining: false,
  isLeaving: false,
};

export const lobbyReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOBBY_ACTIONS.fetch.request:
      return {
        ...state,
        error: null,
        isFetching: true,
      };
    case LOBBY_ACTIONS.fetch.success:
      return {
        ...state,
        lobby: action.payload,
        isFetching: false,
      };
    case LOBBY_ACTIONS.fetch.error:
      return {
        ...state,
        lobby: {},
        error: action.payload,
        isFetching: false,
      };

    case LOBBY_ACTIONS.join.request:
      return {
        ...state,
        isJoining: true,
      };
    case LOBBY_ACTIONS.join.success:
      return {
        ...state,
        isJoining: false,
      };
    case LOBBY_ACTIONS.join.error:
      return {
        ...state,
        isJoining: false,
      };

    case LOBBY_ACTIONS.leave.request:
      return {
        ...state,
        isLeaving: true,
      };
    case LOBBY_ACTIONS.leave.success:
      return {
        ...state,
        isLeaving: false,
      };
    case LOBBY_ACTIONS.leave.error:
      return {
        ...state,
        isLeaving: false,
      };
    case LOBBY_ACTIONS.playerCount.update:
      return {
        ...state,
        lobby: {
          ...state.lobby,
          playerCount: action.payload,
        },
      };
    case LOBBY_ACTIONS.reset:
      return initialState;
    default:
      return state;
  }
};
